// import accountRepository from '@/common/request';
import apiRequestService from '@/commonProject/service/apiRequestService';

export default class counselingRoomRepository {
    /**
     * カウンセリングループ案内取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getCounselingRoomGuidanceApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/romdtl', requestBody, idToken);
        // const { requestServerPost } = accountRepository();
        // const result = await requestServerPost('api/romdtl', requestBody);
        return result;
    }
    /**
     * カウンセリングループ案内地図画像取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getCounselingRoomGuidanceMapImageApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/rommap', requestBody, idToken);
        // const { requestServerPost } = accountRepository();
        // const result = await requestServerPost('api/rommap', requestBody);
        return result;
    }
}
